module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "acknowledgement"
    }
  }, [_c('p', {
    staticStyle: {
      "padding-top": "120px",
      "text-align": "center"
    }
  }, [_vm._v("Mad Larry! Psycho Tuesday! A horror movie in a pill!")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em",
      "padding-top": "15px",
      "text-align": "center"
    }
  }, [_vm._v("---")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em",
      "padding-top": "15px",
      "text-align": "center"
    }
  }, [_vm._v("’When you’re wounded and left on Afghanistan’s plains…")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Jest roll to your rifle and blow out your brains")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("An’ go to your Gawd like a soldier.’")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_vm._v("–Rudyard Kipling, The Young British Soldier")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bdde7154","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/Section0001.vue
// module id = 78
// module chunks = 0